export class GameConstants {

    public static readonly VERSION = "0.0";
    public static readonly DEVELOPMENT = false;
    public static readonly LEVEL_EDITION = false;
    public static readonly SHOW_DEBUG_GEOMETRY = false;
    public static readonly INTERPOLATE_TRAJECTORIES = true;
    public static readonly ALL_UNLOCKED = false;
    public static readonly VERBOSE = false;
    public static readonly GAME_WIDTH = 1024;
    public static readonly GAME_HEIGHT = 768;
    public static readonly TOTAL_MAPS = 30;

    public static readonly SPONSOR_GAMEDISTRIBUTION = "Game Distribution";
    public static readonly SPONSOR_NONE: string = "none";
    public static readonly SPONSOR: string = GameConstants.SPONSOR_NONE;

    // TIPO DE IMPACTOS
    public static readonly IMPACT_BULLET = "impact bullet";
    public static readonly IMPACT_MORTAR = "impact mortar";
    public static readonly IMPACT_MINE = "impact mine";
    public static readonly IMPACT_FIRE = "impact fire";
    public static readonly IMPACT_ELECTRIC = "impact electric";
    public static readonly IMPACT_SUICIDAL_SOLDIER = "impact suicidal soldier";

    // el tick del engine en milisegundos
    public static readonly TIME_STEP = 100;
    public static readonly ENEMY_SPAWNING_DELTA_TICKS = 1;
    public static readonly INITIAL_CREDITS = 40000;
    public static readonly INITIAL_COINS = 0;
    public static readonly INITIAL_LIFES = 10;
    public static readonly CELLS_SIZE = 64;
    public static readonly MAX_UPGRADES = 3;
    public static readonly SUICIDE_ATTACK_COOLDOWN_TICKS = 1500;
    public static readonly SUICIDE_ATTACK_DAMAGE = 1000;
    public static readonly FREEZE_ATTACK_COOLDOWN_TICKS = 500;
    public static readonly FREEZE_ATTACK_DURATION = 30;

    // LOGS TYPES
    public static readonly TYPE_ADD_TURRET = "add turret";
    public static readonly TYPE_SELL_TURRET = "sell turret";
    public static readonly TYPE_UPGRADE_TURRET = "upgrade turret";
    public static readonly TYPE_LEVEL_UP_TURRET = "level up turret";
    public static readonly TYPE_CHANGE_STRATEGY_TURRET = "change strategy turret";
    public static readonly TYPE_CHANGE_FIXED_TARGET_TURRET = "change fixed target turret";

    public static readonly TYPE_NEXT_WAVE = "next wave";

    public static readonly SAVED_GAME_DATA_KEY = "king-rugni-data";
}
